import { call, put } from 'redux-saga/effects';
import { API, graphqlOperation } from 'aws-amplify';
import { getAllVariables } from '../../../services/api';
import {
  getIOTDocument,
  onUpdateIOTDocument,
} from '../../../graphql/iot-documents';
import { store } from '../..';

export function* getThingVariables({ thingId, thingName, typeId }) {
  // Algumas things (especialmente Bluebox) excedem 50 variaveis. A tela
  // "Ver todos" precisa da lista completa para exibir e marcar favoritos.
  const response = yield call(getAllVariables, thingId, 1, 200, typeId);
  yield put({
    type: 'IOT/SET_VARIABLES_THING',
    variables: response.data,
    thingName,
  });
}

const abreConexao = async ({ thing }) => {
  const updateIotSubscription = await onUpdateIOTDocument();
  const newConection = await API.graphql(
    graphqlOperation(updateIotSubscription, { thingName: thing })
  ).subscribe({
    next: (subscribeData) => {
      if (
        subscribeData.value &&
        subscribeData.value.data &&
        subscribeData.value.data.onUpdateIOT
      ) {
        store.dispatch({
          type: 'IOT/SET_VALUES_THING',
          thingName: thing,
          values: subscribeData.value.data.onUpdateIOT,
        });
      }
    },
    error: () => {
      newConection.unsubscribe();
    },
  });
  return newConection;
};

export async function conectaThings({ things }) {
  const iotQuery = await getIOTDocument();
  things.forEach(async (thing) => {
    API.graphql(graphqlOperation(iotQuery, { thingName: thing.thing })).then(
      async (resp) => {
        const data = 'getIOT' in resp ? resp.getIOT || {} : resp.data.getIOT;
        const conexao = await abreConexao(thing);

        store.dispatch({
          type: 'IOT/SET_VALUES_THING',
          thingName: thing.thing,
          values: data,
          unsubscribe: () => conexao.unsubscribe(),
        });
      }
    );
  });
}
